/*
 *
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * 34 Middletown Ave, Atlantic Highlands, NJ 07716
 *
 * THIS SOFTWARE IS THE CONFIDENTIAL AND PROPRIETARY INFORMATION OF
 * Aegis AO Soft LLC and Alexander Orlov.
 *
 * This code may be used, reproduced, modified, or distributed ONLY with the
 * prior written permission of Aegis AO Soft LLC / Alexander Orlov.
 *
 * Author: Alexander Orlov
 * Aegis AO Soft LLC
 *
 */


import apiClient from './client';

export interface HostVersion {
  service: string;
  version: string;
  buildTimeUtc: string | null;
  environment: string;
}

export const systemApi = {
  /** Version + build time of the running backend (Aegis.Back). Anonymous endpoint. */
  getHostVersion: async (): Promise<HostVersion> => {
    const res = await apiClient.get<HostVersion>('/Configuration/host-version');
    return res.data;
  },
};
